import React from 'react';
import { connect } from 'react-redux';

import { getWorkflowConstants } from '~/common/constants/workflow';
import { useIntl } from 'react-intl';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import Icon from '~/ui/components/Icon/Icon';
import Text from '~/ui/components/Text/Text';
import { getFieldDefinitionStatus } from '~/utils/workflow';

import RadioItem from './RadioItem';

function RadioContracts({
  selectedFieldDefinition,
  onClick,
  onCustomFieldClick,
  // connected
  fieldLinks,
}) {
  const intl = useIntl();
  const { contractFieldDefinitions } = getWorkflowConstants(intl);

  return (
    <>
      {contractFieldDefinitions.map((fieldDefinition) => {
        const { isSelected } = getFieldDefinitionStatus({
          fieldDefinition,
          fieldLinks,
          selectedFieldDefinition,
          intl,
        });
        return (
          <RadioItem
            key={fieldDefinition.key}
            option={{
              label: fieldDefinition.label,
              value: fieldDefinition.key,
            }}
            selected={isSelected}
            onClick={() => onClick(fieldDefinition)}
          />
        );
      })}
      <FlexLayout
        alignItems="center"
        px={6}
        py={3}
        space={4}
        sx={{ cursor: 'pointer', '&:hover': { backgroundColor: 'gray-200' } }}
        onClick={onCustomFieldClick}
      >
        <Icon color="blue-500" icon="plus" size="xs" />
        <Text color="blue-500" variant="xs-dense-bold">
          {intl.formatMessage({
            id: 'RadioContracts.customField',
            defaultMessage: 'Custom Field',
            description:
              'Label for custom field option in radio contracts menu',
          })}
        </Text>
      </FlexLayout>
    </>
  );
}

const mapStateToProps = ({ workflow }) => ({
  fieldLinks: workflow.fieldLinks,
});

export default connect(mapStateToProps)(RadioContracts);
